import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';

class Autocomplete extends Component {
  state = {
    // The active selection's index
    activeSuggestion: 0,
    // The suggestions that match the user's input
    filteredSuggestions: [],
    // Whether or not the suggestion list is shown
    showSuggestions: false,
    // What the user has entered
    userInput: '',
  };

  componentDidMount() {
    const { value } = this.props;
    if (value) {
      this.setState({
        userInput: value,
      });
    }
    return null;
  }

  onChange = (e) => {
    const { suggestions } = this.props;
    const userInput = e.currentTarget.value;

    // Filter our suggestions that don't contain the user's input
    const filteredSuggestions = suggestions && suggestions.filter(suggestion => suggestion && suggestion.toLowerCase().indexOf(userInput && userInput.toLowerCase()) > -1);

    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
      userInput,
    });
  };

  onClick = (e) => {
    const { storeText, name } = this.props;
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: e.currentTarget.innerText,
    });
    storeText(name, e.currentTarget.innerText);
  };

  onKeyDown = (e) => {
    const { activeSuggestion, filteredSuggestions } = this.state;

    // User pressed the enter key
    if (e.keyCode === 13) {
      this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        userInput: filteredSuggestions[activeSuggestion],
      });
    }
    // User pressed the up arrow
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    }
    // User pressed the down arrow
    else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };

  render() {
    const {
      onChange,
      onClick,
      onKeyDown,
      state: {
        activeSuggestion, filteredSuggestions, showSuggestions, userInput,
      },
    } = this;

    const {
      message, title, value, action,
    } = this.props;

    let suggestionsListComponent;

    if (showSuggestions && userInput) {
      if (filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul className="list-none mt-0 pl-0" style={{ overflowY: 'auto', width: 'calc(300px + 1 rem)' }}>
            {filteredSuggestions.map((suggestion, index) => {
              let className;

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = 'cursor-pointer';
              }

              return (
                <li className={`${className} p-2 uppercase hover:text-black hover:bg-white `} key={suggestion} onClick={onClick}>
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <div className="no-suggestions">
            <em>{message}</em>
          </div>
        );
      }
    }

    return (
      <Fragment>
        {(action === 'create' || action === 'modify') && (
          <div className="flex flex-col font-americaMonoRegular text-xs uppercase mb-2 ">
            <span>{title}</span>
            <input type="text" onChange={onChange} onKeyDown={onKeyDown} value={userInput} className="mt-2 rounded-full border-1 p-2 bg-white text-black outline-none" />
            {suggestionsListComponent}
          </div>
        )}
        {(action === 'display' || action === 'delete') && (
          <div className="flex flex-col font-americaMonoRegular text-xs uppercase mb-2 ">
            <span>{title}</span>
            <input type="text" value={value} className="mt-2 rounded-full border-1 p-2 bg-grey text-black outline-none" disabled />
          </div>
        )}
      </Fragment>
    );
  }
}

Autocomplete.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  value: PropTypes.string,
  message: PropTypes.string.isRequired,
  storeText: PropTypes.func.isRequired,
};

Autocomplete.defaultProps = {
  value: '',
};

export default Autocomplete;
